import styled from 'styled-components';
import { FullScreenModal } from 'components/component-library/ModalContainer';

export const Wrapper = styled(FullScreenModal)`
    background-color: #fff;
`;

export const Header = styled.header`
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.06);
    height: 70px;
    padding: 0px 30px;

    .vc-grid {
        height: 100%;
    }
`;

export const SearchContainer = styled.div`
    display: flex;
    border: 1px solid #cfcaca;
    border-radius: 3px;
    align-items: center;
    &.menu {
        border: solid 1px #5299d7;
    }
`;

export const Search = styled.div`
    border: 0px;
    display: flex;
    align-items: center;
    padding-left: 5px;
    padding-right: 5px;

    i {
        color: #7a7a7a;
        font-size: 18px;
    }

    span {
        padding: 5px;
    }

    input {
        border: 0px;
        outline: 0;
        height: 34px;
        min-width: 160px;
        color: #7a7a7a;
        &:focus {
            border: 0px;
        }
    }
`;
